import { z } from 'zod';
import { switchParameter, yesNo } from './shared.js';

export default {
  label: 'Fabrication Data', group: 'system',
  description: 'Element and surface construction tables, with mounting-ring spacer lengths.',
  settingsSchema: z.strictObject({
    surface_listing: z.enum(['Auto', 'Yes']).default('Auto').describe('SUR: Auto omits the command and uses CODE V\'s native format selection; Yes requests surface-by-surface output. The documented default is element format except for asymmetric surface types. Explicit SUR No did not disable surface format in captured native probes and is unavailable.'),
    spacers: yesNo('SPA: include native mounting-ring contact-plane spacing along Z. The native default is No (PromptingGuide p175). These distances are not lens vertex thicknesses.'),
  }),
  parameters: [
    { key: 'surface_listing', label: 'Construction format', kind: 'select', options: [
      { value: 'Auto', label: 'CODE V default' }, { value: 'Yes', label: 'Surface listing' },
    ] },
    switchParameter('spacers', 'Mount spacing'),
  ],
  coverage: 'Covers spherical, conic and rotationally symmetric aspheric surfaces, circular apertures, and decentered layouts. Element and surface numbers are CODE V\'s own numbering and can differ from the surface numbers in the lens editor. Not supported: refractive-index, freeform-surface, non-circular or decentered-aperture, CAD and environmental tables.',
} as const;
